import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import usePopOver from "@/hooks/use-popover";
import { IWorkflow } from "@/interfaces/workflow.interface";
import { WorkflowMessages } from "@/messages/workflow/workflow.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { WorkflowTableRow } from "./row";
import { WORKFLOWS_TABLE_COLUMNS } from "../../constants";
import { WorkflowPopover } from "../WorkflowPopover";

interface WorkflowTableProps {
  data: PaginatedResponse<IWorkflow>;
  pagination: Pagination;
  messages: WorkflowMessages;
  resolveWorkflowTypeLabel?: (workflowTypeId: number) => string;
}

export function WorkflowTable({
  data,
  pagination,
  messages,
  resolveWorkflowTypeLabel,
}: WorkflowTableProps) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const {
    openPopover,
    anchorEl,
    closePopover,
    isOpen,
    selected: selectedWorkflow,
  } = usePopOver<IWorkflow>();

  const columns = WORKFLOWS_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`} width={"16%"}>
                  {label}
                </HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items.map((workflow, index) => (
              <WorkflowTableRow
                key={`${index} - ${workflow.id}`}
                workflow={workflow}
                workflows={data.items}
                index={index}
                onOpenPopover={openPopover}
                messages={messages}
                resolveWorkflowTypeLabel={resolveWorkflowTypeLabel}
              />
            ))}
          </TableBody>
        </Table>

        {selectedWorkflow && (
          <WorkflowPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selectedWorkflow={selectedWorkflow}
          />
        )}
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, pageNumber) => changePage(pageNumber)}
      />
    </>
  );
}
